import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './assets/languages/en';
import ar from './assets/languages/ar';
import { getDefaultLanguage } from 'core/services/language';

const defaultLanguage = getDefaultLanguage();

// set default language on first load if not exist
if (!localStorage.getItem('language')) {
	localStorage.setItem('language', 'en');
}

i18n.use(initReactI18next).init({
	resources: { en, ar },
	lng: defaultLanguage,
	fallbackLng: defaultLanguage,
	interpolation: {
		escapeValue: false,
	},
});

export default i18n;
